import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_prediction_cookie~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_prediction_cookie'),
			},
		},
	},
]

export default config
